"use client";

import { useBlogDetailsMaskType } from "../../hooks/use-blog-dtails-mask-type";
import { LoginMaskContent } from "./LoginMaskContent";
import { SubscribeMaskContent } from "./SubscribeMaskContent";

export const BlogDetailsMask = () => {
  const { type } = useBlogDetailsMaskType();

  if (type === "none") return null;

  return (
    <div className="absolute bottom-0 left-0 flex w-full flex-col justify-center">
      <div className="h-20 w-full bg-gradient-to-t from-white to-transparent" />
      <div className="flex w-full justify-center bg-white">
        {type === "login" && (
          <div aria-label="login mask" data-testid="login-mask">
            <LoginMaskContent />
          </div>
        )}
        {type === "subscribe" && (
          <div aria-label="subscribe mask" data-testid="subscribe-mask">
            <SubscribeMaskContent />
          </div>
        )}
      </div>
    </div>
  );
};
